import { useEffect, useState, useLayoutEffect } from "react";

// router
import { useSearchParams } from "react-router-dom";

// services
import { getContract } from "../services/contract";
import { getAppToken } from "../services/auth";

// components
import Dashboard from "./Dashboard";
import Error from "./Error";

export default function Contract({ isMobile, setCurrentBrand }) {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [brandId, setBrandId] = useState("");
  const [userId, setUserId] = useState("");
  const [isMember, setIsMember] = useState(false);
  const [isCustomer, setIsCustomer] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [errorCollection, setErrorCollection] = useState([]);
  const [existingToken, setExistingToken] = useState(false);
  const [linkData, setLinkData] = useState("");

  useLayoutEffect(() => {
    setUserId(searchParams.get("u")); 
    setBrandId(searchParams.get("b"));
    setIsMember(searchParams.get("m") === 'true'? true : false);
    setIsCustomer(searchParams.get("c") === 'true'? true :  false);
    setCurrentBrand(searchParams.get("b"));
    localStorage.setItem("current_brand", searchParams.get("b"));
  }, []);

  useEffect(() => {
    if (userId && brandId && !existingToken) {
      const interval = setInterval(() => {
        getAuthToken(interval);
      }, 1000);
    }
  }, [userId, brandId]);

  useEffect(() => {
    if (existingToken) {
      fetchContract();
    }
  }, [existingToken]);

  const getAuthToken = async (interval) => {
    try {
      const response = await getAppToken();
      if (response.data) {
        localStorage.setItem("access_token_bt", response.data.access_token);
        localStorage.setItem("refresh_token_bt", response.data.access_token);
        clearInterval(interval);
        setExistingToken(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchContract = async () => {
    setIsLoading(true);
    try {
      const response = await getContract(userId, brandId);
      if (response.data.status === "success") {
        setData(response.data.data);
      } else {
        setErrorCollection(response.data.message);
        setBrandId(false);
        setUserId(false);
        if(isCustomer) {
          setLinkData(response.data.data);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {!isLoading ? (
        <>
          {data.headers ? (
            <Dashboard
              data={data}
              userId={userId}
              brandId={brandId}
              isMobile={isMobile}
              isMember={isMember}
              isCustomer={isCustomer}
            />
          ) : (
            <Error
              customTitle={"NO ES POSIBLE FIRMAR EL CONTRATO"}
              errorCollection={errorCollection}
              textButton={"Tokeniza aqui"}
              linkButton={linkData}
            />
          )}
        </>
      ) : (
        <Error hasLoader />
      )}
    </>
  );
}
